module.exports = __webpack_public_path__ + "static/img/rank_54.5268edf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_54.png
// module id = wOCS
// module chunks = 1